
import { defineComponent } from 'vue'
import { FmtUtils } from '@/services'

export default defineComponent({
  name: 'FormInputPostalCodeComponent',
  props: {
    id: String,
    placeholder: String,
    modelValue: String,
    readonly: Boolean,
  },
  emits: ['update:modelValue'],
  data: function () {
    return {
      model: FmtUtils.fmtPostalCode(this.modelValue),
    }
  },
  watch: {
    modelValue() {
      this.model = FmtUtils.fmtPostalCode(this.modelValue)
    },
    model() {
      let value = this.model ?? ''
      value = value.replace(/[^0-9]/g, '')
      if (value.length > 5) {
        value = value.substring(0, 5)
      }
      this.$emit('update:modelValue', value)
      this.model = FmtUtils.fmtPostalCode(value)
    },
  },
  computed: {
    inputClass() {
      if (this.readonly) {
        return 'form-control-plaintext'
      } else {
        return 'form-control'
      }
    },
  },
})
